import { useState, useEffect } from "react";

import {
    Grid,
    FormControlLabel,
    Checkbox,
    Select,
    MenuItem,
} from "@mui/material";

import { request } from "@/Api";
import {
    AccountSectionRow,
    AccountSubtitle,
    AccountInput,
} from "@/account/StyledComponents";
import { SectionEdit } from "@/account/CommonComponents";

export default function SubscriptionSection({
    data,
    setSaved,
    setError,
    setData,
}) {
    const [editing, setEditing] = useState(false);
    const [loading, setLoading] = useState(false);

    const [plan, setPlan] = useState("Basic");
    const [renew, setRenew] = useState(!data.cancel_at_period_end);

    const handleSave = () => {
        setError("");
        setLoading(true);

        request
            .patch("payments/subscription", { cancel_at_period_end: !renew })
            .then((response) => {
                setEditing(false);
                setData({
                    ...data,
                    cancel_at_period_end: response.data.cancel_at_period_end,
                });
                setSaved(true);
            })
            .catch((error) => {
                const msg = Array.isArray(error.response.data.detail)
                    ? error.response.data.detail.map((e) => e.msg).join(", ")
                    : error.response.data.detail;
                setError(msg || "Failed to save");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCancel = () => {
        setEditing(false);
        setRenew(!data.cancel_at_period_end);
    };

    const handleRenew = (event) => {
        setRenew(event.target.checked);
    };

    const handlePlan = (event) => {
        setPlan(event.target.value);
    };

    useEffect(() => {
        setRenew(!data.cancel_at_period_end);
    }, [data]);

    return (
        <Grid item>
            <SectionEdit
                title="Subscription"
                editing={editing}
                loading={loading}
                handleEdit={() => setEditing(true)}
                handleSave={handleSave}
                handleCancel={handleCancel}
            />

            <AccountSectionRow>
                <AccountSubtitle>Plan</AccountSubtitle>
                <AccountInput>
                    {editing ? (
                        <Select value={plan} label="Plan" onChange={handlePlan}>
                            <MenuItem value="Basic">Basic</MenuItem>
                        </Select>
                    ) : (
                        <p>Basic</p>
                    )}
                </AccountInput>
            </AccountSectionRow>

            <AccountSectionRow>
                <AccountSubtitle>Renews On</AccountSubtitle>
                <AccountInput>
                    {editing ? (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={renew}
                                    onChange={handleRenew}
                                />
                            }
                            label="Enable renewal"
                        />
                    ) : (
                        <p>
                            {data.cancel_at_period_end &&
                                "Will become inactive after "}
                            {data.current_period_end}
                        </p>
                    )}
                </AccountInput>
            </AccountSectionRow>
        </Grid>
    );
}
